module.exports = __webpack_public_path__ + "img/samsung-galaxy-s20-fe.3e4993ba.png";